import { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { GenericPageSkeleton } from '../../components/PageSkeletons';
import { RouteConfig } from '../../config/routes';

interface PublicRouteProps {
  component: RouteConfig['component'];
  fallback?: RouteConfig['skeleton'];
}

const PublicRoute = ({ component: Component, fallback: Fallback }: PublicRouteProps) => {
  const Skeleton = Fallback ?? GenericPageSkeleton;
  const { pathname } = useLocation();
  // Key the boundary by path so each navigation mounts a fresh Suspense boundary.
  // Without this, the Outlet reuses this same PublicRoute/Suspense instance across
  // routes; React Router v7 navigations run inside a transition, so a lazy component
  // suspending in an already-revealed boundary keeps showing the previous route
  // instead of the skeleton. A freshly mounted boundary always shows its fallback.
  return (
    <Suspense key={pathname} fallback={<Skeleton />}>
      <Component />
    </Suspense>
  );
};

export default PublicRoute;
